module.exports = __webpack_public_path__ + "img/settings.54011e5c.png";